import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Button from '../../common/Button';
import Input from '../../blocks/Input';
import { requiredValidator, isFormValid, emailValidator } from '../../../utils/validators';
import styles from './ResetPassword.module.scss';

const validators = [
  {
    key: 'email',
    validator: [requiredValidator, emailValidator],
  },
];

function ResetPassword(props) {
  let [email, setEmail] = useState(props.email);
  let [submitting, setSubmitting] = useState(false);

  const buttonDisabled = () => submitting || !isFormValid({ email }, validators);

  const handleChange = (e) => {
    setEmail(e.target.value);

    if (submitting) {
      setSubmitting(false);
    }
  };

  const onSubmit = (e) => {
    setSubmitting(true);
    props.sendEmailPassword(email);

    e.preventDefault();
  };

  return (
    <>
      <form className={styles.form} onSubmit={onSubmit}>
        <h2>Reset Password</h2>

        <label>
          Email Address <span className={styles.required}>*</span>
          <Input
            name="email"
            type="email"
            onChange={handleChange}
            placeholder="Email"
            marginBottom
            validate={[requiredValidator, emailValidator]}
            value={email}
            autocomplete="email"
          />
        </label>

        <div className={styles.settings}>
          <p>
            <Link to="/signin">Sign In</Link>
          </p>
        </div>

        <div className={styles.submitButton}>
          <Button type="submit" text="Reset by email" disabled={buttonDisabled()} />
        </div>
      </form>
    </>
  );
}

export default ResetPassword;

ResetPassword.propTypes = {
  email: PropTypes.string,
  alertSuccess: PropTypes.func.isRequired,
  sendEmailPassword: PropTypes.func.isRequired,
};
